import Spinner from '@rio-cloud/rio-uikit/Spinner';
import { FunctionComponent } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

type QueryStatusDisplayProps = {
    isProcessing: boolean;
    queryId: string | undefined;
};

export const QueryStatusDisplay: FunctionComponent<QueryStatusDisplayProps> = ({ isProcessing, queryId }) => {
    const intl = useIntl();

    if (isProcessing) {
        return (
            <div className="height-40">
                <Spinner
                    isDoubleSized
                    text={intl.formatMessage({ id: 'outboundOrderBook.inspector.dataquery.processingQuery' })}
                />
            </div>
        );
    } else if (queryId) {
        return (
            <p className="margin-x-5 margin-top-20 text-color-gray text-center">
                <span className="text-style-italic">
                    <FormattedMessage id="outboundOrderBook.inspector.dataquery.queryId" />:
                </span>
                {' ' + queryId}
            </p>
        );
    }
};
